// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import {
  SUBSCRIPTION_COMMISSIONS_REDUCER_KEY,
  SUBSCRIPTION_REVENUE_REDUCER_KEY,
} from "..";
import { SUBSCRIPTION_REVENUE_KEY } from "./subscriptionRevenueReducer";
import {
  appStoreSalesMonths,
  appStoresTotalMonth,
  appleAppStoreMonth,
  googlePlayAppStoreCommissionMonth,
  googlePlayAppStoreMonth,
  websiteStoreCommissionMonths,
  websiteStoreMonth,
} from "./staticMonthsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

// subscriber commissions' keys
export const APP_STORE_SALES_TITLE_KEY = "appStoreSales";
export const APPLE_APP_STORE_KEY = "appleAppStore";
export const GOOGLE_PLAY_APP_STORE_KEY = "googlePlayAppStore";
export const WEBSITE_STORE_KEY = "websiteStore";
export const APP_STORES_TOTAL_KEY = "appStoresTotal";

export const SALES_COMMISSIONS_TITLE_KEY = "salesCommissions";
export const APPLE_APP_STORE_COMMISSION_KEY = "appleAppStoreCommission";
export const GOOGLE_PLAY_APP_STORE_COMMISSION_KEY =
  "googlePlayAppStoreCommission";
export const WEBSITE_STORE_COMMISSION_KEY = "websiteStoreCommission";

export const SALES_COMMISSIONS_AMOUNT_TITLE_KEY = "salesCommissionsAmount";
export const APPLE_APP_STORE_COMMISSION_AMOUNT_KEY =
  "appleAppStoreCommissionAmount";
export const GOOGLE_PLAY_APP_STORE_COMMISSION_AMOUNT_KEY =
  "googlePlayAppStoreCommissionAmount";
export const WEBSITE_STORE_COMMISSION_AMOUNT_KEY =
  "websiteStoreCommissionAmount";
export const TOTAL_SALES_COMMISSIONS_AMOUNT_KEY = "totalSalesCommissionsAmount";

export const NET_SUBSCRIPTION_REVENUE_KEY = "netSubscriptionRevenue";

export const subscriptionCommissionsItems = [
  APP_STORE_SALES_TITLE_KEY,
  APPLE_APP_STORE_KEY,
  GOOGLE_PLAY_APP_STORE_KEY,
  WEBSITE_STORE_KEY,
  APP_STORES_TOTAL_KEY,
  SALES_COMMISSIONS_TITLE_KEY,
  APPLE_APP_STORE_COMMISSION_KEY,
  GOOGLE_PLAY_APP_STORE_COMMISSION_KEY,
  WEBSITE_STORE_COMMISSION_KEY,
  SALES_COMMISSIONS_AMOUNT_TITLE_KEY,
  APPLE_APP_STORE_COMMISSION_AMOUNT_KEY,
  GOOGLE_PLAY_APP_STORE_COMMISSION_AMOUNT_KEY,
  WEBSITE_STORE_COMMISSION_AMOUNT_KEY,
  TOTAL_SALES_COMMISSIONS_AMOUNT_KEY,
  NET_SUBSCRIPTION_REVENUE_KEY,
];

export const initialState = {
  [APP_STORE_SALES_TITLE_KEY]: {
    title: "Application Stores % of Sales",
    unit: unitType.INNER_TITLE,
    unitSymbol: getUnitSymbolByUnit(unitType.INNER_TITLE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INNER_TITLE,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return "";
    },
    months: appStoreSalesMonths,
    years: {
      [years.YEAR_1_KEY]: "",
      [years.YEAR_2_KEY]: "",
      [years.YEAR_3_KEY]: "",
      [years.YEAR_4_KEY]: "",
      [years.YEAR_5_KEY]: "",
    },
  },
  [APPLE_APP_STORE_KEY]: {
    title: "Apple App Store",
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 60;
    },
    months: appleAppStoreMonth,
    years: {
      [years.YEAR_1_KEY]: 60,
      [years.YEAR_2_KEY]: 60,
      [years.YEAR_3_KEY]: 60,
      [years.YEAR_4_KEY]: 60,
      [years.YEAR_5_KEY]: 60,
    },
  },
  [GOOGLE_PLAY_APP_STORE_KEY]: {
    title: "Google Play",
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 30;
    },
    months: googlePlayAppStoreMonth,
    years: {
      [years.YEAR_1_KEY]: 30,
      [years.YEAR_2_KEY]: 30,
      [years.YEAR_3_KEY]: 30,
      [years.YEAR_4_KEY]: 30,
      [years.YEAR_5_KEY]: 30,
    },
  },
  [WEBSITE_STORE_KEY]: {
    title: "Website",
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 10;
    },
    months: websiteStoreMonth,
    years: {
      [years.YEAR_1_KEY]: 10,
      [years.YEAR_2_KEY]: 10,
      [years.YEAR_3_KEY]: 10,
      [years.YEAR_4_KEY]: 10,
      [years.YEAR_5_KEY]: 10,
    },
  },
  [APP_STORES_TOTAL_KEY]: {
    title: "Total",
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return (
        Number(
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            APPLE_APP_STORE_KEY
          ]["years"][yearKey]
        ) +
        Number(
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            GOOGLE_PLAY_APP_STORE_KEY
          ]["years"][yearKey]
        ) +
        Number(
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            WEBSITE_STORE_KEY
          ]["years"][yearKey]
        )
      );
    },
    months: appStoresTotalMonth,
    years: {
      [years.YEAR_1_KEY]: 100,
      [years.YEAR_2_KEY]: 100,
      [years.YEAR_3_KEY]: 100,
      [years.YEAR_4_KEY]: 100,
      [years.YEAR_5_KEY]: 100,
    },
  },

  [SALES_COMMISSIONS_TITLE_KEY]: {
    title: "Sales Commissions %",
    unit: unitType.INNER_TITLE,
    unitSymbol: getUnitSymbolByUnit(unitType.INNER_TITLE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INNER_TITLE,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return "";
    },
    months: appStoreSalesMonths,
    years: {
      [years.YEAR_1_KEY]: "",
      [years.YEAR_2_KEY]: "",
      [years.YEAR_3_KEY]: "",
      [years.YEAR_4_KEY]: "",
      [years.YEAR_5_KEY]: "",
    },
  },
  [APPLE_APP_STORE_COMMISSION_KEY]: {
    title: "Apple App Store",
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 30;
    },
    months: googlePlayAppStoreMonth,
    years: {
      [years.YEAR_1_KEY]: 30,
      [years.YEAR_2_KEY]: 30,
      [years.YEAR_3_KEY]: 30,
      [years.YEAR_4_KEY]: 30,
      [years.YEAR_5_KEY]: 30,
    },
  },
  [GOOGLE_PLAY_APP_STORE_COMMISSION_KEY]: {
    title: "Google Play",
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 15;
    },
    months: googlePlayAppStoreCommissionMonth,
    years: {
      [years.YEAR_1_KEY]: 15,
      [years.YEAR_2_KEY]: 15,
      [years.YEAR_3_KEY]: 15,
      [years.YEAR_4_KEY]: 15,
      [years.YEAR_5_KEY]: 15,
    },
  },
  [WEBSITE_STORE_COMMISSION_KEY]: {
    title: "Website",
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: websiteStoreCommissionMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },

  [SALES_COMMISSIONS_AMOUNT_TITLE_KEY]: {
    title: "Sales Commissions USD",
    unit: unitType.INNER_TITLE,
    unitSymbol: getUnitSymbolByUnit(unitType.INNER_TITLE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INNER_TITLE,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return "";
    },
    months: appStoreSalesMonths,
    years: {
      [years.YEAR_1_KEY]: "",
      [years.YEAR_2_KEY]: "",
      [years.YEAR_3_KEY]: "",
      [years.YEAR_4_KEY]: "",
      [years.YEAR_5_KEY]: "",
    },
  },
  [APPLE_APP_STORE_COMMISSION_AMOUNT_KEY]: {
    title: "Apple App Store",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const result =
        (getReducerFunc(SUBSCRIPTION_REVENUE_REDUCER_KEY)[
          SUBSCRIPTION_REVENUE_KEY
        ].calculate(yearKey, getReducerFunc, companyType) *
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            APPLE_APP_STORE_KEY
          ]["years"][yearKey] *
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            APPLE_APP_STORE_COMMISSION_KEY
          ]["years"][yearKey]) /
        10000;
      return result.toFixed(0);
    },
    months: websiteStoreCommissionMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [GOOGLE_PLAY_APP_STORE_COMMISSION_AMOUNT_KEY]: {
    title: "Google Play",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const result =
        (getReducerFunc(SUBSCRIPTION_REVENUE_REDUCER_KEY)[
          SUBSCRIPTION_REVENUE_KEY
        ].calculate(yearKey, getReducerFunc, companyType) *
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            GOOGLE_PLAY_APP_STORE_KEY
          ]["years"][yearKey] *
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            GOOGLE_PLAY_APP_STORE_COMMISSION_KEY
          ]["years"][yearKey]) /
        10000;
      return result.toFixed(0);
    },
    months: websiteStoreCommissionMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [WEBSITE_STORE_COMMISSION_AMOUNT_KEY]: {
    title: "Website",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const result =
        (getReducerFunc(SUBSCRIPTION_REVENUE_REDUCER_KEY)[
          SUBSCRIPTION_REVENUE_KEY
        ].calculate(yearKey, getReducerFunc, companyType) *
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            WEBSITE_STORE_KEY
          ]["years"][yearKey] *
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            WEBSITE_STORE_COMMISSION_KEY
          ]["years"][yearKey]) /
        10000;
      return result.toFixed(0);
    },
    months: websiteStoreCommissionMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [TOTAL_SALES_COMMISSIONS_AMOUNT_KEY]: {
    title: "Total Sales Commission",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const result =
        Number(
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            APPLE_APP_STORE_COMMISSION_AMOUNT_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            GOOGLE_PLAY_APP_STORE_COMMISSION_AMOUNT_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            WEBSITE_STORE_COMMISSION_AMOUNT_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        );
      return result.toFixed(0);
    },
    months: websiteStoreCommissionMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },

  [NET_SUBSCRIPTION_REVENUE_KEY]: {
    title: "Net Subscription Revenue",
    highlight: true,
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const result =
        Number(
          getReducerFunc(SUBSCRIPTION_REVENUE_REDUCER_KEY)[
            SUBSCRIPTION_REVENUE_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) -
        Number(
          getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
            TOTAL_SALES_COMMISSIONS_AMOUNT_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        );
      return result.toFixed(0);
    },
    months: websiteStoreCommissionMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const subscriptionCommissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SUBSCRIPTION_COMMISSION_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_SUBSCRIPTION_COMMISSION_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_SUBSCRIPTION_COMMISSION_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_SUBSCRIPTION_COMMISSION_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default subscriptionCommissionsReducer;
